import { useRouter } from 'next/router';

import { checkWlPage } from '../helpers/checkWlPage';

export const useIsWlPage = (): boolean => {
  const { query } = useRouter();

  return checkWlPage(query);
};
